module.exports = __webpack_public_path__ + "40861be0039cdae45645082d4e5d2c9f.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/sn_logo_white.png
// module id = 646
// module chunks = 0